import './style/style.css';
import keyData from './keyData';
import Keyboard from './keyboard';

const keyboard = new Keyboard();
keyboard.init();
const keyboardNode = document.querySelector('.keyboard');
const { textArea } = keyboard;

const setCaretPosition = (start, end) => {
  keyboard.textArea.setSelectionRange(start, end);
};

function changeLanguage() {
  const keys = document.querySelectorAll('.key');
  // keyboard.recognizer.lang = keyboard.lang === 'ru' ? 'ru-Ru' : 'en-US';
  for (let i = 0; i < keys.length; i += 1) {
    if (keyboard.capslock) {
      keys[i].textContent = keyboard.caps[keyboard.lang][i];
    } else { keys[i].textContent = keyboard.down[keyboard.lang][i]; }
  }
}
function ctrlAlt() {
  if (keyboard.alt && keyboard.ctrl) {
    // eslint-disable-next-line no-unused-expressions
    keyboard.lang === 'ru' ? (keyboard.lang = 'en') : (keyboard.lang = 'ru');
    // if (keyboard.lang === 'ru') {
    //   keyboard.lang = 'en';
    // } else { keyboard.lang = 'ru'; }
    keyboard.getStorage(keyData);
    changeLanguage();
    localStorage.lang = keyboard.lang;
  }
}
function changeShift() {
  const keys = document.querySelectorAll('.key');
  for (let i = 0; i < keys.length; i += 1) {
    if (keyboard.shift) {
      keys[i].textContent = keyboard.shiftArr[keyboard.lang][i];
    } else { keys[i].textContent = keyboard.down[keyboard.lang][i]; }
  }
}

keyboard.getStorage(keyData);

function typeText(text, keyboardItem, caretPosStart, caretPosEnd) {
  const { textArea } = keyboardItem;
  if (caretPosStart === caretPosEnd) {
    textArea.value = `${textArea.value.slice(
      0,
      caretPosStart,
    )}${text}${textArea.value.slice(caretPosStart)}`;
    setCaretPosition(caretPosStart + text.length, caretPosEnd + text.length);
  } else {
    textArea.value = `${textArea.value.slice(
      0,
      caretPosStart,
    )}${text}${textArea.value.slice(caretPosEnd)}`;
    setCaretPosition(caretPosStart + text.length, caretPosStart + text.length);
  }
}
function cutText(keyboardItem, caretPosStart, caretPosEnd) {
  keyboardItem.clipboard = textArea.value.slice(caretPosStart, caretPosEnd);
  textArea.value = `${textArea.value.slice(
    0,
    caretPosStart,
  )}${textArea.value.slice(caretPosEnd)}`;
  setCaretPosition(caretPosStart, caretPosStart);
}
function copyText(keyboardItem, caretPosStart, caretPosEnd) {
  keyboardItem.clipboard = textArea.value.slice(caretPosStart, caretPosEnd);
}

keyboardNode.addEventListener('click', (event) => {
  const caretPosStart = textArea.selectionStart;
  const caretPosEnd = textArea.selectionEnd;
  textArea.focus();
  const currentKey = document.querySelector(`.${event.target.dataset.code}`);
  console.log('currentkey', currentKey);
  const currentKeys = document.querySelectorAll('.key');

  const resetCtrlAlt = () => {
    currentKeys.forEach((key) => {
      if (key.innerHTML === 'Ctrl' || key.innerHTML === 'Alt') {
        key.classList.remove('active');
      }
    });
    keyboard.alt = false;
    keyboard.ctrl = false;
  };
  let checkKeyInKeyboard = false;
  for (let i = 0; i < currentKeys.length; i += 1) {
    if (event.target.dataset.code === currentKeys[i].dataset.code) {
      checkKeyInKeyboard = true;
    }
  }
  if (checkKeyInKeyboard && currentKey) {
    switch (currentKey.textContent) {
      case 'Backspace':
        textArea.value = textArea.value.slice(0, textArea.value.length - 1);
        // currentKey.classList.add('active');
        break;
      case 'Tab':
        textArea.value += '\t';
        // currentKey.classList.add('active');
        break;
      case 'CapsLock':
        currentKey.classList.toggle('active');
        keyboard.switchCapsLock();
        changeLanguage();
        break;
      case 'Enter':
        textArea.value += '\n';
        // currentKey.classList.add('active');
        break;
      case 'Shift':
        keyboard.switchShift();
        changeShift();
        currentKey.classList.toggle('active');
        break;
      case 'Ctrl':
        currentKey.classList.toggle('active');
        if (currentKey.matches('.active')) {
          keyboard.ctrl = true;
        } else {
          keyboard.ctrl = false;
        }
        if (keyboard.ctrl && keyboard.alt) {
          ctrlAlt();
          resetCtrlAlt();
        }
        break;
      case 'Alt':
        currentKey.classList.toggle('active');
        if (currentKey.matches('.active')) {
          keyboard.alt = true;
        } else {
          keyboard.alt = false;
        }
        if (keyboard.ctrl && keyboard.alt) {
          ctrlAlt();
          resetCtrlAlt();
        }
        break;
      case 'Win':
        // currentKey.classList.add('active');
        break;
      case 'Del':
        textArea.value = `${textArea.value.slice(
          0,
          caretPosStart,
        )}${textArea.value.slice(caretPosStart + 1)}`;
        setCaretPosition(caretPosStart, caretPosStart);
        //  currentKey.classList.add('active');
        break;
      case '←':
        setCaretPosition(caretPosStart - 1, caretPosEnd - 1);
        break;
      case '→':
        setCaretPosition(caretPosStart + 1, caretPosEnd + 1);
        break;
      case '↑':
        window.getSelection().modify('move', 'left', 'paragraph');
        break;
      case '↓':
        window.getSelection().modify('move', 'right', 'paragraph');
        break;

      default:
        if (keyboard.ctrl && event.target.dataset.code === 'KeyC') {
          copyText(keyboard, caretPosStart, caretPosEnd);
          // keyboard.clipboard = textArea.value.slice(caretPosStart, caretPosEnd);
          navigator.clipboard.writeText(
            keyboard.textArea.value.slice(caretPosStart, caretPosEnd),
          );
          console.log(event.code);
        } else if (keyboard.ctrl && event.target.dataset.code === 'KeyV') {
          typeText(keyboard.clipboard, keyboard, caretPosStart, caretPosEnd);
        } else if (keyboard.ctrl && event.target.dataset.code === 'KeyX') {
          cutText(keyboard, caretPosStart, caretPosEnd);
          console.log(event.code);
        } else if (keyboard.ctrl && event.target.dataset.code === 'KeyA') {
          console.log('keya', textArea.value.length - 1);
          setCaretPosition(0, textArea.value.length);
        } else {
          typeText(
            currentKey.textContent,
            keyboard,
            caretPosStart,
            caretPosEnd,
          );
        }
        keyboard.checkAlt();
        keyboard.checkCtrl();
        keyboard.checkShift();
    }
  }

  if (keyboard.sound) {
    keyboard.audio.currentTime = 0;
    keyboard.audio.play();
  }
});

document.addEventListener('keydown', (event) => {
  const caretPosStart = textArea.selectionStart;
  const caretPosEnd = textArea.selectionEnd;
  textArea.focus();
  const currentKey = document.querySelector(`.${event.code}`);
  const currentKeys = document.querySelectorAll('.key');
  let checkKeyInKeyboard = false;
  for (let i = 0; i < currentKeys.length; i += 1) {
    if (event.code === currentKeys[i].dataset.code) {
      checkKeyInKeyboard = true;
    }
  }
  if (checkKeyInKeyboard) {
    switch (event.code) {
      case 'Backspace':
        currentKey.classList.add('active');
        break;
      case 'Tab':
        event.preventDefault();
        textArea.value += '\t';
        currentKey.classList.add('active');
        break;
      case 'CapsLock':
        event.preventDefault();
        keyboard.switchCapsLock();
        changeLanguage();
        currentKey.classList.toggle('active');
        break;
      case 'Enter':
        currentKey.classList.add('active');
        break;
      case 'ShiftLeft':
        event.preventDefault();
        keyboard.switchShift();
        changeShift();
        currentKey.classList.toggle('active');
        break;
      case 'ShiftRight':
        event.preventDefault();
        keyboard.switchShift();
        changeShift();
        currentKey.classList.toggle('active');
        break;
      case 'ControlLeft':
        event.preventDefault();
        currentKey.classList.add('active');
        if (currentKey.matches('.active')) {
          keyboard.ctrl = true;
        } else {
          keyboard.ctrl = false;
        }
        if (keyboard.ctrl && keyboard.alt) {
          ctrlAlt();
          keyboard.recognizer.lang = keyboard.recognizer.lang === 'ru-Ru'
            ? 'en-Eng'
            : 'ru-Ru';
        }
        break;
      case 'MetaLeft':
        event.preventDefault();
        currentKey.classList.add('active');
        break;
      case 'AltLeft':
        event.preventDefault();
        currentKey.classList.add('active');
        if (currentKey.matches('.active')) {
          keyboard.alt = true;
        } else {
          keyboard.alt = false;
        }
        if (keyboard.ctrl && keyboard.alt) {
          ctrlAlt();
        }
        break;
      case 'AltRight':
        event.preventDefault();
        currentKey.classList.add('active');
        if (currentKey.matches('.active')) {
          keyboard.alt = true;
        } else {
          keyboard.alt = false;
        }
        if (keyboard.ctrl && keyboard.alt) {
          ctrlAlt();
        }
        break;
      case 'ControlRight':
        event.preventDefault();
        currentKey.classList.add('active');
        if (currentKey.matches('.active')) {
          keyboard.ctrl = true;
        } else {
          keyboard.ctrl = false;
        }
        if (keyboard.ctrl && keyboard.alt) {
          ctrlAlt();
        }
        break;
      case 'Delete':
        currentKey.classList.add('active');
        break;
      case 'ArrowLeft':
        currentKey.classList.add('active');
        break;
      case 'ArrowDown':
        currentKey.classList.add('active');
        break;
      case 'ArrowRight':
        currentKey.classList.add('active');
        break;
      case 'ArrowUp':
        currentKey.classList.add('active');
        break;
      default:
        // event.preventDefault();
        if (keyboard.ctrl && event.code === 'KeyC') {
          copyText(keyboard, caretPosStart, caretPosEnd);
          // keyboard.clipboard = textArea.value.slice(
          //   caretPosStart,
          //   caretPosEnd,
          // );
          // navigator.clipboard.writeText(
          //   keyboard.textArea.value.slice(caretPosStart, caretPosEnd),
          // );
          console.log(event.code);
        } else if (keyboard.ctrl && event.code === 'KeyV') {
          // typeText(keyboard.clipboard, keyboard, caretPosStart, caretPosEnd);
        } else if (keyboard.ctrl && event.code === 'KeyX') {
          // cutText(keyboard, caretPosStart, caretPosEnd);
          copyText(keyboard, caretPosStart, caretPosEnd);
          // keyboard.clipboard = textArea.value.slice(caretPosStart, caretPosEnd);
          console.log(event.code);
        } else if (keyboard.ctrl && event.code === 'KeyA') {
          console.log('keya', textArea.value.length - 1);
          // setCaretPosition(0, textArea.value.length);
        } else {
          event.preventDefault();
          typeText(currentKey.textContent, keyboard, caretPosStart, caretPosEnd);
          currentKey.classList.add('active');
        }
    }
  }
});
document.addEventListener('keyup', (event) => {
  const currentKey = document.querySelector(`.${event.code}`);
  const currentKeys = document.querySelectorAll('.key');
  let checkKeyInKeyboard = false;
  for (let i = 0; i < currentKeys.length; i += 1) {
    if (event.code === currentKeys[i].dataset.code) {
      checkKeyInKeyboard = true;
    }
  }
  if (checkKeyInKeyboard) {
    switch (event.code) {
      case 'CapsLock':
        keyboard.checkAlt();
        keyboard.checkCtrl();
        keyboard.checkShift();
        break;
      case 'ShiftLeft':
        keyboard.checkAlt();
        keyboard.checkCtrl();
        break;
      case 'ShiftRight':
        keyboard.checkAlt();
        keyboard.checkCtrl();
        break;
      case 'AltLeft':
        if (keyboard.ctrl && keyboard.alt) {
          keyboard.ctrl = false;
          keyboard.alt = false;
          const ctrlLeft = document.querySelector('.ControlLeft');
          const ctrlRight = document.querySelector('.ControlRight');
          ctrlLeft.classList.remove('active');
          ctrlRight.classList.remove('active');
          currentKey.classList.remove('active');
        }
        currentKey.classList.remove('active');
        keyboard.checkShift();
        break;
      case 'AltRight':
        if (keyboard.ctrl && keyboard.alt) {
          keyboard.ctrl = false;
          keyboard.alt = false;
          const ctrlLeft = document.querySelector('.ControlLeft');
          const ctrlRight = document.querySelector('.ControlRight');
          ctrlLeft.classList.remove('active');
          ctrlRight.classList.remove('active');
          currentKey.classList.remove('active');
        }
        currentKey.classList.remove('active');
        keyboard.checkShift();
        break;
      case 'ControlLeft':
        if (keyboard.ctrl && keyboard.alt) {
          keyboard.ctrl = false;
          keyboard.alt = false;
          const altLeft = document.querySelector('.AltLeft');
          const altRight = document.querySelector('.AltRight');

          altLeft.classList.remove('active');
          altRight.classList.remove('active');
          currentKey.classList.remove('active');
        }
        currentKey.classList.remove('active');
        keyboard.checkShift();
        break;
      case 'ControlRight':
        if (keyboard.ctrl && keyboard.alt) {
          keyboard.ctrl = false;
          keyboard.alt = false;
          const altLeft = document.querySelector('.AltLeft');
          const altRight = document.querySelector('.AltRight');

          altLeft.classList.remove('active');
          altRight.classList.remove('active');
          currentKey.classList.remove('active');
        }
        currentKey.classList.remove('active');
        keyboard.checkShift();
        break;

      default:
        currentKey.classList.remove('active');
        keyboard.checkAlt();
        keyboard.checkCtrl();
        keyboard.checkShift();
    }
  }
  if (keyboard.sound) {
    keyboard.audio.currentTime = 0;
    keyboard.audio.play();
  }
});
